import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import axios from 'axios';

export const ServicioOfrecido = (props) => {
	const {
		servicio,
		setServicioId,
		setModalAnadirServicio,
		generarListaDias,
		getPeriodos,
		comprobaciones,
		setModalAnadirServicioShareCare,
	} = props;
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
	return (
		<>
			<Accordion>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls='panel1a-content'
					id='panel1a-header'
				>
					<div className='servicio-perfil-empresa'>
						<div className='centradorLeft'>
							<h5>{servicio.servicio_id.nombre}</h5>
						</div>
						<div className='centradorLeft'>Precio: {servicio.precioMin} €</div>
						<div className='centradorLeft'> Duracion: {servicio.horasMin} min</div>
						<div className='extras-servicioOfrecido-perfilAgencia-nuevo'>
							{servicio.domicilio && (
								<div className='centrador'>
									<div className='domicilio-servicioOfrecido-perfilAgencia-nuevo'>
										Domicilio
									</div>
								</div>
							)}
							{servicio.shareCare && (
								<div className='centrador'>
									<div className='shareCare-servicioOfrecido-perfilAgencia-nuevo'>
										ShareCare
									</div>
								</div>
							)}
						</div>
					</div>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<div className='cuerpo-descripcion-servicio'>
							<div className='centradorLeft descripcion-servicio'>
								{servicio.descripcion}
							</div>
							<div className='centradorRight'>
								<button
									className='btn login-boton d-flex align-items-center gap-2 btn login-boton px-3 py-2 shadow-sm'
									onClick={() => {
										if (comprobaciones() == true) {
											if (Usuario.tipo === 'usuarioNormal') {
												axios({
													/* Sending a post request to the server. */
													method: 'post',
													url:
														window.ipdirection +
														'logs?logstream=clickAnadirServicio',
													headers: {
														Authorization: 'Bearer ' + Usuario.access,
													},
													data: {
														usuario: Usuario.cliente.usuario.id,
														infoServicio: servicio.servicio_id,
														accion: 'clickAnadirServicio',
													},
												})
													.then((response) => {})
													.catch((error) => {});
											}
											setServicioId(servicio.id);
											getPeriodos(servicio.id);
											generarListaDias(servicio.id);
											// comprobamos el tipo de servicio
											setModalAnadirServicioShareCare(true);
										}
									}}
								>
									<i class="bi bi-bag-fill"></i>
									<div className='centrador'>
										<b>Añadir</b>
									</div>
								</button>
							</div>
						</div>
					</Typography>
				</AccordionDetails>
			</Accordion>
		</>
	);
};
